import { combineReducers } from 'redux'
import User from './stores/user/user.reducer'
import Children from './stores/children/children.reducer'
import School from './stores/school/school.reducer'
import SchoolTeam from './stores/school-team/school-team.reducer'
import SchoolData from './stores/school-data/school-data.reducer'
import Providers from './stores/providers/providers.reducer'

const Reducer = combineReducers({
  User,
  Children,
  School,
  SchoolTeam,
  SchoolData,
  Providers
})

export default Reducer
